import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "@phosphor-icons/react";

export const CoverageMarquee = ({ content }) => {
  const areas = content?.coverage || [];
  return (
    <section id="coverage" className="relative bg-black py-5 md:py-6 overflow-hidden" data-testid="coverage-marquee">
      <Marquee speed={55} gradient={false} autoFill>
        {areas.map((a, i) => (
          <div key={i} className="flex items-center gap-6 mx-6">
            <span className="font-display text-taxi text-3xl md:text-5xl uppercase">{a}</span>
            <Star size={22} weight="fill" className="text-taxi/70" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
